export const getNotificationTime = (createdAt) => {
  if (!createdAt) {
    return "N/A";
  }

  const createdTime = new Date(createdAt).getTime();
  const currentTime = Date.now();

  if (Number.isNaN(createdTime)) {
    return "N/A";
  }

  const difference = Math.max(
    0,
    currentTime - createdTime
  );

  const seconds = Math.floor(
    difference / 1000
  );

  const minutes = Math.floor(
    seconds / 60
  );

  const hours = Math.floor(
    minutes / 60
  );

  const days = Math.floor(
    hours / 24
  );

  const weeks = Math.floor(
    days / 7
  );

  const months = Math.floor(
    days / 30
  );

  const years = Math.floor(
    days / 365
  );

  if (seconds < 60) {
    return "Just now";
  }

  if (minutes < 60) {
    return `${minutes} mins`;
  }

  if (hours < 24) {
    return `${hours} hours`;
  }

  if (days < 7) {
    return `${days} days`;
  }

  if (days < 30) {
    return `${weeks} weeks`;
  }

  if (days < 365) {
    return `${months} months`;
  }

  return `${years} years`;
};